/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "joysticks";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface JoysticksFlightMode {
}

export enum JoysticksFlightMode_Enum {
  INVALID = 0,
  MODE_1 = 1,
  MODE_2 = 2,
  MODE_3 = 3,
  UNRECOGNIZED = -1,
}

export function joysticksFlightMode_EnumFromJSON(object: any): JoysticksFlightMode_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return JoysticksFlightMode_Enum.INVALID;
    case 1:
    case "MODE_1":
      return JoysticksFlightMode_Enum.MODE_1;
    case 2:
    case "MODE_2":
      return JoysticksFlightMode_Enum.MODE_2;
    case 3:
    case "MODE_3":
      return JoysticksFlightMode_Enum.MODE_3;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JoysticksFlightMode_Enum.UNRECOGNIZED;
  }
}

export function joysticksFlightMode_EnumToJSON(object: JoysticksFlightMode_Enum): string {
  switch (object) {
    case JoysticksFlightMode_Enum.INVALID:
      return "INVALID";
    case JoysticksFlightMode_Enum.MODE_1:
      return "MODE_1";
    case JoysticksFlightMode_Enum.MODE_2:
      return "MODE_2";
    case JoysticksFlightMode_Enum.MODE_3:
      return "MODE_3";
    case JoysticksFlightMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseJoysticksFlightMode(): JoysticksFlightMode {
  return {};
}

export const JoysticksFlightMode = {
  encode(_: JoysticksFlightMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JoysticksFlightMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoysticksFlightMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): JoysticksFlightMode {
    return {};
  },

  toJSON(_: JoysticksFlightMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<JoysticksFlightMode>, I>>(base?: I): JoysticksFlightMode {
    return JoysticksFlightMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoysticksFlightMode>, I>>(_: I): JoysticksFlightMode {
    const message = createBaseJoysticksFlightMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
